import React from 'react'
import DropdownTableData from './DropdownTableData'
import FixedTextTableData from '../../components/tableComponents/FixedTextTableData'
import VariableTextTableData from '../../components/tableComponents/VariableTextTableData'
import PasswordTableInput from './PasswordTableInput'
import { isValidEmail, isValidUsername } from './validateInput'

const NewTableRow = ({ dataElement, setDataElement, groups }) => {
	function updateData(attribute, value) {
		setDataElement({ ...dataElement, [attribute]: value })
	}

	return (
		<tr>
			<FixedTextTableData text={''} />
			<VariableTextTableData
				text={dataElement.username}
				setText={(newText) => updateData('username', newText)}
				containsValidText={isValidUsername(dataElement.username)}
			/>
			<VariableTextTableData
				text={dataElement.email}
				setText={(newText) => updateData('email', newText)}
				containsValidText={isValidEmail(dataElement.email)}
			/>
			<VariableTextTableData
				text={dataElement.phonenumber}
				setText={(newText) => updateData('phonenumber', newText)}
			/>
			<DropdownTableData
				options={groups}
				selectedOption={dataElement.group || null}
				setSelectedOption={(newOption) => updateData('group', newOption)}
			/>
			<PasswordTableInput
				password={dataElement.plainPassword}
				setPassword={(newPassword) => updateData('plainPassword', newPassword)}
			/>
		</tr>
	)
}

export default NewTableRow
